module.exports = __webpack_public_path__ + "img/6-1.25469cd0.jpg";